export interface PlatformInfo {
  platform: string;
  fileType: "exe" | "dmg";
}

export const detectPlatform = (): PlatformInfo => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/win/i.test(userAgent)) {
    return {
      platform: "Windows",
      fileType: "exe",
    };
  }

  if (/mac/i.test(userAgent)) {
    const canvas: HTMLCanvasElement = document.createElement("canvas");
    const gl: WebGLRenderingContext | null =
      (canvas.getContext("webgl") as WebGLRenderingContext) ||
      (canvas.getContext("experimental-webgl") as WebGLRenderingContext);

    if (gl) {
      const info: WEBGL_debug_renderer_info | null = gl.getExtension(
        "WEBGL_debug_renderer_info",
      );
      if (info) {
        const renderer: string | null = gl.getParameter(
          info.UNMASKED_RENDERER_WEBGL,
        );

        if (renderer && renderer.toLowerCase().includes("apple")) {
          return {
            platform: "Apple Silicon",
            fileType: "dmg",
          };
        } else if (renderer && renderer.toLowerCase().includes("intel")) {
          return {
            platform: "Intel Mac",
            fileType: "dmg",
          };
        }
      }
    }

    return {
      platform: "Apple Silicon", // Default for Mac
      fileType: "dmg",
    };
  }

  // Default fallback
  return {
    platform: "Unknown",
    fileType: "dmg",
  };
};
